import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useI18n } from "@/i18n";
import { Reveal, SectionHead } from "@/components/motion";

export const Timeline = () => {
  const { t } = useI18n();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 80%", "end 60%"] });
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);
  return (
    <section id="fonctionnement" className="relative bg-[var(--navy)] py-24 lg:py-32" data-testid="timeline-section">
      <div className="container-x">
        <SectionHead index="02" eyebrow={t.how.eyebrow} title={t.how.title} />
        <div ref={ref} className="relative mt-16">
          <div className="absolute left-0 right-0 top-[7px] hidden h-px bg-white/15 lg:block" />
          <motion.div style={{ scaleX }} className="absolute left-0 right-0 top-[7px] hidden h-px origin-left bg-[var(--gold)] lg:block" />
          <div className="absolute bottom-0 left-[7px] top-0 w-px bg-white/15 lg:hidden" />
          <ol className="grid gap-8 lg:grid-cols-9 lg:gap-4">
            {t.how.steps.map((s, i) => (
              <Reveal key={s.t} delay={i * 0.06} className="relative pl-10 lg:pl-0 lg:pt-10" data-testid={`timeline-step-${i + 1}`}>
                <span className={`absolute left-0 top-1 h-[15px] w-[15px] rotate-45 border-2 lg:top-0 ${i === 5 ? "border-[var(--ember)] bg-[var(--ember)]" : "border-[var(--gold)] bg-[var(--navy)]"}`} />
                <p className="font-mono text-xs text-[var(--gold)]">{String(i + 1).padStart(2, "0")}</p>
                <p className="font-display mt-2 text-2xl font-bold uppercase leading-none">{s.t}</p>
                <p className="mt-2 text-sm text-[var(--steel)]">{s.d}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
